<template>
  <div class="transfer-page">
  </div>
</template>

<script>
import cookie from '@utils/cookie'
export default {
  name: 'home',
  data () {
    return {}
  },
  created () {
    const token = cookie.get('kg-client-token')
    if (!token) {
      this.$router.push('/sign/sign-in')
    }
    this.$store.dispatch('getUserInfo').then(result => {
      if (result.identity !== 0) {
        this.$router.push({ name: 'Home' })
      } else {
        this.$router.push({ name: 'userHome' })
      }
    })
  }
}
</script>
<style scoped lang="scss">
.transfer-page {}
</style>
